export default function useEnv() {
  const env = import.meta.env;

  const isLocal = !env.PROD;
  const isDev = location.hostname === "connect3.pageone.co.uk";
  const isProd = location.hostname === "connect.criticogroup.com";

  const FEATURE_FLAGS = {
    CAMPAIGN_UI: !isProd,
  };

  return {
    isLocal,
    isProd,
    isDev,
    FEATURE_FLAGS,
    apiUrl: env.VITE_APP_BASE_URL,
    keycloakUrl: env.VITE_APP_KEYCLOAK_URL,
    keycloakRealm: env.VITE_APP_KEYCLOAK_REALM,
    keycloakClientId: env.VITE_APP_KEYCLOAK_CLIENTID,
    skipLogin: env.VITE_APP_SKIP_LOGIN === "true",
  };
}
